import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const NewTeam = lazy(() =>
  import("../../../../../../app-settings").then((module) => ({
    default: module.default.EditTeamSettings,
  }))
);

export const newTeamNRO: NavigationRoutingObject = {
  Component: NewTeam,
  componentFeatureFlippers: ["territories_v2"],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("new-team-nro-heading", "New Team"),
  pageNameForTracking: () => "New Team",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return featureOn("territories") && hasPermission("appGroup", { permission: "editTeams" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/app_settings/app_settings/territories/:appGroupId",
};
